export const socialsData = {
    github: 'https://github.com/abubakar003m',
    facebook: 'https://www.facebook.com/profile.php?id=100009505691996',
    linkedIn: 'https://www.linkedin.com/in/abubakar003/',
    instagram: 'https://www.instagram.com/abubakar003m/',
    codepen: `tel:${+923057165645}`,
    twitter: 'https://www.fiverr.com/abubakaraziz003',
    reddit: 'https://www.facebook.com/profile.php?id=100009505691996',
    blogger: "https://wa.me/923057165645?text=Welcome! How can i help you ?",
    medium: 'https://www.fiverr.com/abubakaraziz003',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: "https://wa.me/923057165645?text=Welcome! How can i help you ?"
}